const isPdf = (url) => /(.pdf)/.test(url)

export default isPdf
